<template>
  <div class="main">
    <div class="main_top">
      <div>
        <!-- <el-input
        class="search"
        placeholder="请输入内容"
        v-model="userSearch"
        clearable
        size="small"
        @change="SearchChange"
      >
      </el-input> -->
        <el-select
          v-model="params.specid"
          placeholder="请选择专业"
          @change="GetEvaDataList"
        >
          <el-option
            v-for="item in majorList"
            :key="item.orgid"
            :label="item.orgname"
            :value="item.orgid"
          >
          </el-option>
        </el-select>
      </div>
      <div>
        <Button icon="md-add" @click="addEva('新增')"> 新增 </Button>
        <Button icon="ios-create" @click="addEva('编辑')"> 编辑 </Button>
        <Button icon="md-trash" @click="delEvaluparams"> 删除 </Button>
      </div>
      <Modal v-model="modal1" title="保存参数" footer-hide>
        <el-form
          :model="formInline"
          :rules="ruleInline"
          ref="formInline"
          label-width="120px"
          class="demo-formInline"
        >
          <el-form-item label="测评参数值" prop="evaparvalue">
            <el-input v-model="formInline.evaparvalue"></el-input>
          </el-form-item>
          <el-form-item label="测评参数名称" prop="itemdetailid">
            <el-select
              v-model="formInline.itemdetailid"
              placeholder="请选择参数名称"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in evaNameList"
                :label="item.description"
                :value="item.itemdetailid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类" prop="evatype">
            <el-select
              v-model="formInline.evatype"
              placeholder="请选择分类"
              style="width: 100%"
            >
              <el-option label="中心" value="0"></el-option>
              <el-option label="专业" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业" prop="specid">
            <el-select
              v-model="formInline.specid"
              placeholder="请选择专业名称"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in majorList"
                :key="item.orgid"
                :label="item.orgname"
                :value="item.orgid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="evapardesc">
            <el-input
              v-model="formInline.evapardesc"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSubmit('formInline')"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </Modal>
    </div>
    <div class="main_body">
      <el-table
        ref="singleTable"
        :data="evaDataList"
        highlight-current-row
        @current-change="evaChange"
        style="width: 100%"
        stripe
      >
        <el-table-column type="index" label="序号" width="80" align="center">
        </el-table-column>
        <el-table-column
          property="evaparname"
          label="测评参数名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="evaparvalue"
          label="测评参数值"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="evaparitem"
          label="测评参数项目"
          align="center"
        >
        </el-table-column>
        <el-table-column property="evaType" label="测评参数分类" align="center">
        </el-table-column>
        <el-table-column property="evapardesc" label="备注" align="center">
        </el-table-column>
      </el-table>

      <div>
        <el-pagination
          style="text-align: right; margin-top: 20px"
          :hide-on-single-page="true"
          :total="total"
          :page-size="params.pagesize"
          :current-page="params.pageindex"
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../../api/index";

export default {
  data() {
    return {
      modal1: false,
      diatitle: "",
      majorList: [], //专业列表
      params: {
        specid: "", //专业id
        pagesize: 13, //每页显示数
        pageindex: 1, //当前页
      },
      userSearch: "",
      evaDataList: [],
      total: 1, //分页总条数
      msg: "",
      evaItem: {}, //用户选中项
      evaNameList: [], //参数名称列表
      formInline: {
        itemdetailid: "",
        evaparvalue: "",
        evapardesc: "",
        evatype: "",
        specid: "",
      },
      ruleInline: {
        itemdetailid: [
          { required: true, message: "请选择测评参数名称!", trigger: "change" },
        ],
        evaparvalue: [
          { required: true, message: "请输入测评参数值!", trigger: "blur" },
        ],
        evatype: [
          { required: true, message: "请选择分类!", trigger: "change" },
        ],
        specid: [{ required: true, message: "请选择专业!", trigger: "change" }],
      },
    };
  },
  created() {
    this.GetspecialtynList();
  },
  methods: {
    //搜索
    SearchChange(val) {
      console.log(val);
    },
    //用户表格选中项
    evaChange(val) {
      this.evaItem = val;
    },
    //获取专业列表
    async GetspecialtynList() {
      const req = await Api.organization.GetspecialtynList();
      if (req.success != true) return this.$Message.info(req.msg);
      this.majorList = req.rows;
    },
    handleCurrentChange(val) {
      this.params.pageindex = val;
      this.GetEvaDataList();
    },
    //获取测评参数列表
    async GetEvaDataList() {
      console.log(this.params);
      const res = await Api.eva.GetDataList(this.params);
      if (!res.success) return this.$Message.error(res.msg);
      this.evaDataList = res.rows;
      this.total = res.total;
    },
    //新增编辑参数
    async addEva(msg) {
      const res = await Api.dictionary.getDataDictionary();
      let itemid = "";
      for (let i = 0; i < res.rows.length; i++) {
        const element = res.rows[i];
        if (element.itemcode == "EvaluationParam") {
          itemid = element.itemid;
        }
      }
      const req = await Api.dictionary.GetDataItemDetailTreeList(itemid);
      this.evaNameList = req.rows;
      if (msg == "编辑") {
        this.msg = "编辑";
        if (JSON.stringify(this.evaItem) == "{}")
          return this.$Message.info("请选择要编辑的参数！");
        this.formInline = JSON.parse(JSON.stringify(this.evaItem));
        this.formInline.itemdetailid = this.evaItem.evaparname;
        this.formInline.evatype = 0 ? "中心" : "专业";
      } else if (msg == "新增") {
        this.msg = "新增";
        this.formInline = {
          itemdetailid: "",
          evaparvalue: "",
          evapardesc: "",
          evatype: "",
          specid: "",
        };
      }
      this.modal1 = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          if (this.msg == "编辑") {
            this.formInline.itemdetailid = this.evaItem.itemdetailid;
            this.formInline.evatype = "中心" ? 0 : 1;
          }

          const res = await Api.eva.SaveData(this.formInline);
          if (res.success != true) return this.$Message.info(res.msg);
          this.$Message.success(res.msg);
          this.modal1 = false;
        } else {
        }
      });
    },
    //删除用户
    async delEvaluparams() {
      if (JSON.stringify(this.evaItem) == "{}")
        return this.$Message.info("请选择要删除的参数！");
      this.$confirm("此操作将永久删除该参数, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          console.log(this.evaItem);
          const res = await Api.eva.DelData([this.evaItem.teaevaparid]);
          if (res.success) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            console.log(this.specid);
            this.GetEvaDataList();
          }
          this.GetSchoolTreeList();
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .main_top {
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding: 15px 15px 0 15px;
    .search {
      width: 220px;
    }
    .dropdown {
      display: inline-block;
      margin-bottom: 0;
      font-weight: 400;
      text-align: center;
      vertical-align: middle;
      touch-action: manipulation;
      cursor: pointer;
      background-image: none;
      border: 1px solid transparent;
      white-space: nowrap;
      line-height: 1.5;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      height: 32px;
      line-height: 29px;
      padding: 0 15px;
      font-size: 14px;
      border-radius: 4px;
      transition: color 0.2s linear, background-color 0.2s linear,
        border 0.2s linear, box-shadow 0.2s linear;
      color: #515a6e;
      background-color: #fff;
      border-color: #dcdee2;
    }
    > div {
      display: flex;
      justify-content: space-between;
      > div {
        margin-right: 10px;
      }
      > button {
        margin-right: 10px;
      }
    }
  }
}
/deep/.demo-formInline {
  padding-right: 20px;
}
</style>